export const TOOLTIP_TEXT = {
  senderText: "By default, the sender email is set to 'materialcerts@guidemark.info' However, if you wish to change it, please note that the allowed domain is '3208tech.com'.",
};